import { Routes, Route } from "react-router-dom";

/* Auth */
import Login from "./pages/Login/Login";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import ProtectedRoute from "./components/ProtectedRoute";

/* Layout */
import SharedLayout from "./components/sharedLayout/SharedLayout";
import Home from "./pages/Home/Home";

/* Admin Dashboard */
import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import SupplierCandidateList from "./components/ListOfOpenJobs/SupplierCandidates"; // Was commented as AdminAccordion, using SupplierCandidateList as per existing code
import ViewFile from "./components/ListOfOpenJobs/ViewFile";

/* Supplier Management */
import SupplierManagement from "./pages/SupplierManagement/SupplierManagement";
import AddSupplier from "./components/SupplierManagement/AddSupplier";
import EditSupplier from "./components/SupplierManagement/EditSupplier";
import ViewSupplier from "./components/SupplierManagement/ViewSupplier";

/* Job Management */
import JobManagement from "./pages/JobManagement/JobManagement";
import AddJob from "./components/JobManagement/AddJob";
import EditJob from "./components/JobManagement/EditJob";

/* Skill Management */
import SkillManagement from "./pages/SkillManagement/SkillManagement";
import AddSkill from "./components/SkillMangement/AddSkill";
import EditSkill from "./components/SkillMangement/EditSkill";

/* CV Search */
import ResumeListComp from "./components/CVSearch/CvSearchManagement";

/* Customer Management */
import CustomerMangComp from "./components/Customers/Customer";
import AddCustomer from "./components/Customers/AddCustomer";
import EditCustomer from "./components/Customers/EditCustomer";
import CustomerContacts from "./components/Customers/CustomerContacts";

/* Interview Tracking */
import InterviewTrack from "./components/InterviewListing/InterviewTrack";

/* Supplier Dashboard */
import SupplierDashboard from "./pages/SupplierDashboard/SupplierDashboard";

/* Candidate Management */
import CandidateManagement from "./pages/CandidateMange/CandidateMange";
import AddCandidate from "./components/CandidateManagement/AddCandidate";
import EditCandidate from "./components/CandidateManagement/EditCandidate";
import ViewCandidate from "./components/CandidateManagement/ViewCandidate";

/* Profile */
import { Profile } from "./uicomponents/Profile";

const AppRoutes = () => {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/resetpassword/:key" element={<ResetPassword />} />

            {/* Protected Routes Wrapper */}
            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <SharedLayout />
                    </ProtectedRoute>
                }
            >
                {/* Dashboard / Home */}
                <Route path="/" element={<Home />} />
                <Route path="/admindashboard" element={<AdminDashboard />} />

                {/* Admin Dashboard Sub-routes */}
                <Route
                    path="/admindashboard/adminAccordion"
                    // element={<AdminAccordion />}
                    element={<SupplierCandidateList />}
                />
                <Route path="/admindashboard/viewFile" element={<ViewFile />} />

                {/* Supplier Admin */}
                <Route path="/suppliermanagement" element={<SupplierManagement />} />
                <Route
                    path="/suppliermanagement/addSupplier"
                    element={<AddSupplier />}
                />
                <Route
                    path="/suppliermanagement/editSupplier"
                    element={<EditSupplier />}
                />
                <Route
                    path="/suppliermanagement/ViewSupplier"
                    element={<ViewSupplier />}
                />

                {/* Jobs */}
                <Route path="/jobs" element={<JobManagement />} />
                <Route path="/jobs/addJob" element={<AddJob />} />
                <Route path="/jobs/editJob" element={<EditJob />} />

                {/* Skills */}
                <Route path="/skills" element={<SkillManagement />} />
                <Route path="/skills/addSkill" element={<AddSkill />} />
                <Route path="/skills/editSkill" element={<EditSkill />} />

                {/* CV Search */}
                <Route path="/cv_search" element={<ResumeListComp />} />

                {/* Customers */}
                <Route path="/customers" element={<CustomerMangComp />} />
                <Route path="/customers/addCustomer" element={<AddCustomer />} />
                <Route path="/customers/editCustomer" element={<EditCustomer />} />
                <Route
                    path="/customers/contacts"
                    element={<CustomerContacts />}
                />

                {/* InterviewTrack */}
                <Route path="/interview_info" element={<InterviewTrack />} />

                {/* Supplier */}
                <Route path="/supplierdashboard" element={<SupplierDashboard />} />

                {/* Candidate */}
                <Route path="/candidate_data" element={<CandidateManagement />} />
                <Route
                    path="/candidate_data/addCandidate"
                    element={<AddCandidate />}
                />
                <Route
                    path="/candidate_data/editcandidate"
                    element={<EditCandidate />}
                />
                <Route
                    path="/candidate_data/Viewcandidate"
                    element={<ViewCandidate />}
                />
                <Route path="/candidate_data/viewFile" element={<ViewFile />} />

                {/* Profile */}
                <Route path="/profile" element={<Profile />} />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
